import { render, staticRenderFns } from "./readBook.vue?vue&type=template&id=d15068c6&scoped=true&"
import script from "./readBook.vue?vue&type=script&lang=js&"
export * from "./readBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15068c6",
  null
  
)

export default component.exports